// src/components/PricingGuaranteeCard.tsx
import React from 'react';
import styled from 'styled-components';
import { Pause, Check } from 'lucide-react';

/* ──────────────────────────────────────────────────────────
   Wrapper – full‑bleed panel that houses the two dashed cards
   ────────────────────────────────────────────────────────── */
const GuaranteeWrap = styled.div`
  width: min(1380px, calc(100% - 2rem));
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  gap: 3rem;

  padding: 3rem;
  border-radius: 20px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 1.75rem;
    padding: 2.25rem 1.5rem;
    width: auto;
  }
`;

/* ──────────────────────────────────────────────────────────
   Single dashed card
   ────────────────────────────────────────────────────────── */
const GuaranteeItem = styled.div`
  padding: 2.5rem;
  border: 1px dashed rgba(0, 0, 0, 0.15);
  border-radius: 16px;

  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: transparent;
`;

/* ──────────────────────────────────────────────────────────
   Titles & body copy
   ────────────────────────────────────────────────────────── */
const GuaranteeTitle = styled.h4`
  margin: 0;
  font-size: 1.35rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.65rem;

  svg {
    flex-shrink: 0;
  }
`;

const GuaranteeText = styled.p`
  margin: 0;
  font-size: 1rem;
  line-height: 1.55;
  color: #6b6b6b;
`;

export default function PricingGuaranteeCard() {
  return (
    <GuaranteeWrap>
      {/* Pause guarantee */}
      <GuaranteeItem>
        <GuaranteeTitle>
          <Pause size={22} strokeWidth={2} /> Hit pause whenever
        </GuaranteeTitle>
        <GuaranteeText>
          Need a breather? Freeze your membership at any time—quick, painless,
          and pressure‑free.
        </GuaranteeText>
      </GuaranteeItem>

      {/* Custom‑built guarantee */}
      <GuaranteeItem>
        <GuaranteeTitle>
          <Check size={22} strokeWidth={2} /> Crafted just for you
        </GuaranteeTitle>
        <GuaranteeText>
          Every deliverable is built from scratch—no templates, no carbon
          copies. Your outcome is as unique as your goals.
        </GuaranteeText>
      </GuaranteeItem>
    </GuaranteeWrap>
  );
}
